(function() {
  'use strict';
  if (window.__gmTitleColorsBooted) return;
  window.__gmTitleColorsBooted = true;

  var TITLE_COLORS = ['#F3E9DF', '#B884C8', '#F5A08E', '#C42F86', '#2E5E8F', '#B7B66C', '#2A2333'];
  var COLOR_CYCLE_MS = 5000;
  var entries = [];
  var interval = null;

  var LETTER_TEXT_SELECTORS = [
    '.gm-subpage-title',
    '.gm-admin-tab'
  ];

  var SOLID_TEXT_SELECTORS = [
    '.gm-admin-list-title',
    '.gm-coming-soon-heading',
    '.gm-coming-soon-label'
  ];

  var BORDER_SELECTORS = [
    '.gm-admin-radio-table-scroll'
  ];

  function assignLetterColorIndices(total) {
    var n = TITLE_COLORS.length;
    if (total <= 0) return [];
    var indices = [];
    for (var i = 0; i < total; i++) {
      var candidate = Math.round(i * (n - 1) / Math.max(total - 1, 1));
      if (i > 0 && candidate === indices[i - 1]) {
        candidate = (candidate + 1) % n;
      }
      indices.push(candidate);
    }
    return indices;
  }

  function spreadIndex(index, total) {
    return assignLetterColorIndices(total)[index] || 0;
  }

  function applyEntry(entry) {
    if (!entry.el || !entry.el.isConnected) return;
    var color = TITLE_COLORS[entry.baseIndex % TITLE_COLORS.length];
    if (entry.prop === 'borderColor') {
      entry.el.style.borderColor = color;
    } else {
      entry.el.style.color = color;
    }
  }

  function syncPaint() {
    entries.forEach(applyEntry);
  }

  function tick() {
    entries.forEach(function(entry) {
      if (!entry.cycle) return;
      entry.baseIndex = (entry.baseIndex + 1) % TITLE_COLORS.length;
    });
    syncPaint();
  }

  function ensureInterval() {
    if (!interval) interval = setInterval(tick, COLOR_CYCLE_MS);
  }

  function applyStaticColor(el, baseIndex, prop) {
    if (!el) return;
    prop = prop || 'color';
    var color = TITLE_COLORS[baseIndex % TITLE_COLORS.length];
    if (prop === 'borderColor') {
      el.style.borderColor = color;
    } else {
      el.style.color = color;
    }
  }

  function register(el, baseIndex, prop, cycle) {
    if (!el) return;
    prop = prop || 'color';
    if (cycle !== true) cycle = false;
    var existing = null;
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].el === el && entries[i].prop === prop) {
        existing = entries[i];
        break;
      }
    }
    if (existing) {
      existing.baseIndex = baseIndex;
      existing.cycle = cycle;
    } else {
      entries.push({ el: el, baseIndex: baseIndex, prop: prop, cycle: cycle });
    }
    applyEntry({ el: el, baseIndex: baseIndex, prop: prop });
  }

  function escHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function colorizeLettersHtml(text, letterClass) {
    letterClass = letterClass || 'gm-color-letter';
    var safe = escHtml(text);
    var nonSpace = safe.replace(/\s/g, '').length;
    var colorIndices = assignLetterColorIndices(nonSpace || 1);
    var html = '';
    var letterIndex = 0;
    for (var i = 0; i < safe.length; i++) {
      var ch = safe.charAt(i);
      if (ch === ' ') {
        html += ' ';
      } else {
        var color = TITLE_COLORS[colorIndices[letterIndex]];
        html += '<span class="' + letterClass + '" style="color:' + color + '">' + ch + '</span>';
        letterIndex++;
      }
    }
    return html;
  }

  function colorizeElement(el, shouldCycle) {
    if (!el || el.dataset.gmColorized === '1') return;
    var text = el.textContent.trim();
    if (!text) return;
    el.dataset.gmColorized = '1';
    el.innerHTML = colorizeLettersHtml(text, 'gm-color-letter');
    if (shouldCycle === false) return;
    var letters = el.querySelectorAll('.gm-color-letter');
    var total = letters.length;
    var colorIndices = assignLetterColorIndices(total);
    letters.forEach(function(letter, index) {
      register(letter, colorIndices[index], 'color', true);
    });
  }

  function initTitleLetters(root) {
    root = root || document;
    var letters = root.querySelectorAll('.cs-title-letter');
    if (!letters.length) return;
    var total = letters.length;
    var colorIndices = assignLetterColorIndices(total);
    letters.forEach(function(letter, index) {
      register(letter, colorIndices[index], 'color', true);
    });
    ensureInterval();
  }

  function initSolidColorText(root) {
    root = root || document;
    var index = 0;
    SOLID_TEXT_SELECTORS.forEach(function(selector) {
      root.querySelectorAll(selector).forEach(function(el) {
        el.setAttribute('data-gm-color-solid', 'true');
        applyStaticColor(el, index % TITLE_COLORS.length, 'color');
        index++;
      });
    });
  }

  function initColorfulText(root) {
    root = root || document;
    LETTER_TEXT_SELECTORS.forEach(function(selector) {
      root.querySelectorAll(selector).forEach(function(el) {
        colorizeElement(el, false);
      });
    });

    initSolidColorText(root);

    var subtitle = root.querySelector('.gm-header .cs-subtitle');
    if (subtitle) colorizeElement(subtitle, false);
  }

  function initColorfulBorders(root) {
    root = root || document;
    BORDER_SELECTORS.forEach(function(selector, selectorIndex) {
      root.querySelectorAll(selector).forEach(function(el, index) {
        el.setAttribute('data-gm-color-border', 'true');
        register(el, (selectorIndex + index) % TITLE_COLORS.length, 'borderColor', true);
      });
    });
    ensureInterval();
  }

  function initColorfulPage(root) {
    root = root || document;
    initTitleLetters(root);
    initColorfulText(root);
    initColorfulBorders(root);
    ensureInterval();
  }

  function clearGreetingLetters() {
    entries = entries.filter(function(entry) {
      return !(entry.el.classList && entry.el.classList.contains('cs-greeting-letter'));
    });
  }

  function initGreetingLetters(container) {
    if (!container) return;
    if (typeof container === 'string') container = document.querySelector(container);
    if (!container) return;
    clearGreetingLetters();
    var letters = container.querySelectorAll('.cs-greeting-letter');
    if (!letters.length) return;
    var total = letters.length;
    var colorIndices = assignLetterColorIndices(total);
    letters.forEach(function(letter, index) {
      register(letter, colorIndices[index], 'color', true);
    });
    syncPaint();
    ensureInterval();
  }

  window.__gmTitleColors = {
    colors: TITLE_COLORS,
    spreadIndex: spreadIndex,
    assignLetterColorIndices: assignLetterColorIndices,
    initTitleLetters: initTitleLetters,
    initColorfulPage: initColorfulPage,
    initGreetingLetters: initGreetingLetters,
    clearGreetingLetters: clearGreetingLetters,
    colorizeLettersHtml: colorizeLettersHtml,
    colorizeElement: colorizeElement
  };

  document.addEventListener('DOMContentLoaded', function() {
    if (document.querySelector('.gm-page') || document.querySelector('.cs-page')) {
      initColorfulPage(document);
    }
  });

  window.addEventListener('gm-colorful-refresh', function() {
    initColorfulPage(document);
  });
})();
